.project-steps-graphic-bar{margin-bottom:15px;border-top:1px solid #d9dddf;padding-top:1em}.workspace-button{width:200px;display:inline-block}
/*# sourceMappingURL=production-workspace-header.component.css.map */
